<template>
  <footer class="main-footer d-flex p-2 px-3 bg-white border-top">
    <div :class="[contained ? 'container' : 'container-fluid', 'h-100']">
      <div class="text-center py-2">
        <span class="copyright my-auto">{{ copyright }}</span>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "main-footer",
  props: {
    /**
     * The footer menu items.
     */
    menuItems: {
      type: Array,
      default() {
        return []
      },
    },
    /**
     * The copyright information.
     */
    copyright: {
      type: String,
      default: "Campost Payment Admin © 2023 CAMPOST",
    },
    /**
     * Whether the footer should be wrapped in a container, or not.
     */
    contained: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
